import StudentActivityNotificationApi from './StudentActivityNotificationApi';
export default StudentActivityNotificationApi;
